/**
 * @generated SignedSource<<9e70e230645cf1f9fa1d46d90f2293f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbackRowFragment$data = {
  readonly approximateTimestamp: number;
  readonly id: string;
  readonly proposal: {
    readonly updateHistory: ReadonlyArray<{
      readonly timestamp: number;
    }>;
  };
  readonly reason: string;
  readonly sender: {
    readonly address: {
      readonly address: string;
      readonly resolvedName: {
        readonly address: string;
        readonly " $fragmentSpreads": FragmentRefs<"NounResolvedLinkFragment">;
      };
    };
  };
  readonly votes: {
    readonly amount: {
      readonly amount: string;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackRowTextFragment">;
  readonly " $fragmentType": "FeedbackRowFragment";
};
export type FeedbackRowFragment$key = {
  readonly " $data"?: FeedbackRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackRowFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedbackRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VotingPower",
      "kind": "LinkedField",
      "name": "votes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TokenAmount",
          "kind": "LinkedField",
          "name": "amount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OnChainProposal",
      "kind": "LinkedField",
      "name": "proposal",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProposalUpdate",
          "kind": "LinkedField",
          "name": "updateHistory",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timestamp",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Delegate",
      "kind": "LinkedField",
      "name": "sender",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ResolvedName",
              "kind": "LinkedField",
              "name": "resolvedName",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NounResolvedLinkFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approximateTimestamp",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeedbackRowTextFragment"
    }
  ],
  "type": "ProposalFeedback",
  "abstractKey": null
};
})();

(node as any).hash = "1dd30f4450642f75fde2ce025a0a23ee";

export default node;
